import { Component, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs';
import { AdminService } from '../services/admin.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DealerDocument } from '../../shared/models/dealer.document.interface';
import { FileUpload } from '../../shared/models/file.upload.interface';
import { GenericDialogData } from '../models/generic.dialog.interface';
import { FileService } from '../../shared/services/file.service';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent {

  fileBytes?: string;
  importFile?: any;
  constructor(private adminService: AdminService, public dialogRef: MatDialogRef<DocumentComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericDialogData) { }
  document: DealerDocument;

  errors: string;
  isRequesting: boolean;
  ngOnInit() {
    let documentId = this.data.id;
    let dealerId = this.adminService.getDealerId();

    if (documentId == null) {
      this.document = {} as DealerDocument;
      this.document.document_IsActive = true;
      this.document.dealer_ID = dealerId;
    }
    else {
      this.adminService.getDocument(documentId)
        .subscribe({
          next: (data) => {
            this.document = data;
          }
        });
    }
  }

  saveDocument(form: NgForm) {
    if (this.importFile == undefined && this.document.dealerDocument_ID == null) {
      alert($localize`No file provided`);
      return;
    }

    if (this.importFile != undefined) {
      if (this.importFile.type != 'application/pdf') {
        alert($localize`File must be a PDF`);
        return;
      }
    }

    if (form.valid) {
      this.isRequesting = true;
      this.saveDocumentAttachment(this.document);
    }
  }

  onError(response: string) {
    this.isRequesting = false;

    window.alert($localize`Sorry, something went wrong.  Please contact Bidit Support.` + 'r\n' + response);
    console.log(response);
  }

  saveDocumentAttachment(document: DealerDocument) {
    // Set File Information
    if (this.importFile != undefined) {
    this.document.attachment = {
      fileName: this.importFile.name,
      fileSize: this.importFile.size,
      fileType: this.importFile.type,
      lastModifiedTime: this.importFile.lastModified,
      lastModifiedDate: this.importFile.lastModifiedDate,
    } as FileUpload;

      this.document.attachment.fileAsBase64 = this.fileBytes;
    }

    this.isRequesting = true;
    this.adminService.saveDocument(this.document)
      .pipe(finalize(() => this.isRequesting = false))
      .subscribe(
        {
          next: (result) => {
            if (result) {
              this.dialogRef.close(this.data);
            }
          },
          error: (error: string) => this.onError(error)
        });
  } 

  onNoClick(): void {
    this.dialogRef.close();
  }
}
